export default "__VITE_ASSET__CWeYpAnP__"